export const mockData = {
  sidebar: {
    bodycamFootage: [
      {
        id: 'bc-1',
        title: 'Traffic Stop – DUI Arrest, Highway 26',
        date: '2024-01-15',
      },
      {
        id: 'bc-2',
        title: 'Domestic Disturbance – 1245 Oak Street',
        date: '2024-01-14',
      },
      {
        id: 'bc-3',
        title: 'Stolen Vehicle Recovery – Mall Parking Lot',
        date: '2024-01-13',
      },
      {
        id: 'bc-4',
        title: 'Welfare Check – Elderly Resident Assist',
        date: '2024-01-12',
      },
    ],
    chatHistory: [
      {
        id: 'ch-1',
        title: 'Willow Street Burglary – Patrol Report Draft',
        date: '2024-01-15',
      },
      {
        id: 'ch-4',
        title: 'Crisis Response Guidance',
        date: '2024-01-14',
      },
      {
        id: 'ch-5',
        title: 'Community Engagement Planning',
        date: '2024-01-13',
      },
    ],
    activeInvestigations: [
      {
        id: 'ch-2',
        title: 'Willow Street Burglary – CID Lead Intake',
        date: '2024-01-14',
      },
      {
        id: 'ch-3',
        title: 'Willow Street Burglary – CID Investigation',
        date: '2024-01-13',
      },
    ],
    activeIncidents: [
      {
        id: 'incident-1',
        title: '1104 Main Street',
        date: '2024-01-15',
      },
      {
        id: 'incident-2',
        title: '2847 Oak Avenue',
        date: '2024-01-15',
      },
      {
        id: 'incident-3',
        title: '615 Elm Street',
        date: '2024-01-15',
      },
    ],
    archived: [
      {
        id: 'ar-1',
        title: 'Drug Interdiction – Vehicle Search Documentation',
        date: '2023-12-15',
      },
      {
        id: 'ar-2',
        title: 'Armed Robbery – Witness Interview Record',
        date: '2023-12-10',
      },
      {
        id: 'ar-3',
        title: 'Public Intoxication – Response Procedures',
        date: '2023-12-05',
      },
    ],
  },
  conversations: {
    'notification-alert': [
      {
        id: '1',
        content:
          "Dispatching to 1104 Main Street. I'm seeing some safety flags. Possible aggressive animals and a history of disturbances.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 120000),
      },
    ],
    'incident-1': [
      {
        id: '1',
        content:
          "Dispatching to 1104 Main Street. I'm seeing some safety flags. Possible aggressive animals and a history of disturbances. I'm ready to listen for notes as soon as it's safe.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 180000),
      },
    ],
    'incident-2': [
      {
        id: '1',
        content:
          "Dispatching to 2847 Oak Avenue. I'm seeing some safety flags. Prior weapons call at this location and mental health history on file. I'm ready to listen for notes as soon as it's safe.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 240000),
      },
    ],
    'incident-3': [
      {
        id: '1',
        content:
          "Dispatching to 615 Elm Street. I'm seeing some safety flags. Known drug activity at this location and officer safety alert on file. I'm ready to listen for notes as soon as it's safe.",
        role: 'assistant',
        timestamp: new Date(Date.now() - 300000),
      },
    ],
    'ch-1': [
      {
        id: '1',
        content:
          "Let's work together to gather every detail of this incident. To start, when did it occur and at what time?",
        role: 'assistant',
        timestamp: new Date(Date.now() - 1200000),
      },
      {
        id: '2',
        content: 'June 22, 2025 at approximately 9:30 PM.',
        role: 'user',
        timestamp: new Date(Date.now() - 1100000),
      },
      {
        id: '3',
        content:
          'Great, thanks. Could you describe what happened and any key details of the incident?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 1000000),
      },
      {
        id: '4',
        content: 'It was a burglary at a residence.',
        role: 'user',
        timestamp: new Date(Date.now() - 900000),
      },
      {
        id: '5',
        content:
          'Understood. Where exactly did this take place? Please share the full address and type of location (e.g., home, business).',
        role: 'assistant',
        timestamp: new Date(Date.now() - 800000),
      },
      {
        id: '6',
        content: 'Private residence at 123 Willow Street.',
        role: 'user',
        timestamp: new Date(Date.now() - 700000),
      },
      {
        id: '7',
        content:
          'Perfect. Was anyone present or affected? If so, who and what was their condition?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 600000),
      },
      {
        id: '8',
        content: 'The homeowner, Mrs. Jane Doe, was present but uninjured.',
        role: 'user',
        timestamp: new Date(Date.now() - 500000),
      },
      {
        id: '9',
        content:
          'Thanks. Did you notice any signs of forced entry or damage at the scene?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 400000),
      },
      {
        id: '10',
        content: 'Yes—back door kicked in, clear shoeprints near entry.',
        role: 'user',
        timestamp: new Date(Date.now() - 300000),
      },
      {
        id: '11',
        content:
          'Got it. What evidence did you collect, and were there any witnesses or neighbors who saw anything?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 200000),
      },
      {
        id: '12',
        content:
          'I recovered a pry bar from the yard and got a statement from Mrs. Greene, next door.',
        role: 'user',
        timestamp: new Date(Date.now() - 100000),
      },
      {
        id: '13',
        content:
          "Excellent. I've recorded the evidence and witness details. Would you like to review our draft narrative now or add any more information?",
        role: 'assistant',
        timestamp: new Date(),
      },
    ],
    'ch-2': [
      {
        id: '1',
        content:
          'I have a tip about possible suspects linked to the Willow Street burglary.',
        role: 'user',
        timestamp: new Date(Date.now() - 400000),
      },
      {
        id: '2',
        content:
          'Great lead. Who provided the tip, and when did they observe the activity?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 380000),
      },
      {
        id: '3',
        content:
          'The business owner saw a white van parked behind the building last night around 10 PM, with two subjects unloading bags.',
        role: 'user',
        timestamp: new Date(Date.now() - 350000),
      },
      {
        id: '4',
        content:
          'Thank you. Can you describe the vehicle in more detail—make, model, and any part of the license plate?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 320000),
      },
      {
        id: '5',
        content: "It was a white cargo-style van, partial plate 'L7K'.",
        role: 'user',
        timestamp: new Date(Date.now() - 300000),
      },
      {
        id: '6',
        content:
          'Understood. Did the tip include descriptions of the individuals or any distinguishing features?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 280000),
      },
      {
        id: '7',
        content:
          'No clear description, but the business owner mentioned one suspect wore a dark hoodie and the other wore a mask.',
        role: 'user',
        timestamp: new Date(Date.now() - 250000),
      },
      {
        id: '8',
        content:
          'Got it. Is there any video or photo evidence available, and if so, where can you collect it?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 200000),
      },
      {
        id: '9',
        content:
          'Yes—surveillance footage is available. I can retrieve it from the business today.',
        role: 'user',
        timestamp: new Date(Date.now() - 150000),
      },
      {
        id: '10',
        content:
          "Excellent. Please secure the footage and note its location. Finally, what's the best contact for follow-up questions?",
        role: 'assistant',
        timestamp: new Date(Date.now() - 100000),
      },
      {
        id: '11',
        content: 'You can reach the owner, Mr. Allen, at (555) 123-4567.',
        role: 'user',
        timestamp: new Date(Date.now() - 50000),
      },
      {
        id: '12',
        content:
          "Perfect. I've flagged this lead for CID review with all critical details recorded: tipster, timing, vehicle info, descriptions, and evidence location. Anything else to add?",
        role: 'assistant',
        timestamp: new Date(),
      },
    ],
    'ch-3': [
      {
        id: '1',
        content: 'Show me all new leads for the Willow Street case.',
        role: 'user',
        timestamp: new Date(Date.now() - 120000),
      },
      {
        id: '2',
        content: `Leads for Willow St. Burglary (Case #2024-0721):

• Patrol Lead [06/21 13:22]: Business owner reports white van (L7K...) unloading bags; surveillance video available. Status: Pending Evidence Collection
• Social Media [06/21 12:44]: Anonymous tip—stolen property posted for sale in local Facebook group. Status: Under Review
• Public Submission [06/21 10:19]: Neighbor submitted photo of unknown subject in alley, 03:20am. Status: Needs Patrol Follow-Up

Would you like an investigation status update?`,
        role: 'assistant',
        timestamp: new Date(Date.now() - 100000),
      },
      {
        id: '3',
        content: 'Yes, give me the investigation status.',
        role: 'user',
        timestamp: new Date(Date.now() - 80000),
      },
      {
        id: '4',
        content: `[Thinking…]
• Multiple leads reference late-night activity in the alley and a white van at different locations.
• The van links the business tip to potential stolen property movement—possible use as a mobile stash or getaway.
• Surveillance video can establish a visual ID and timeline; compare with social media post timing.
• Anonymous social post appeared within 2 hours of the burglary—suggests rapid disposal or insider involvement.
• Toolmarks on the pry bar and shoeprints could tie to recent cases; recommend latent print and toolmark comparison.
• No current suspects. Pattern indicates organized activity, not random.
[End of thinking]`,
        role: 'assistant-thinking',
        timestamp: new Date(Date.now() - 70000),
      },
      {
        id: '5',
        content: `Investigation Status [Willow St. Burglary]:
- Forced entry at rear confirmed; pry bar and shoeprints logged as evidence.
- Three leads active: van surveillance footage pending, social media sale post flagged, public-submitted photo in queue for patrol follow-up.
- Immediate action: Retrieve surveillance video, assign digital forensics review for social media accounts, confirm timeline with neighbor.
- No suspects in custody. Case active and high-priority.

Insight:
The timing of the sale posts online strongly suggests suspects are monitoring social media trends, or using a third party for quick fencing. Recommend cross-checking with area pawnshops and reviewing similar burglary MOs in surrounding jurisdictions.

Would you like to assign follow-ups, generate an evidence summary, or request deeper link analysis across cases?`,
        role: 'assistant',
        timestamp: new Date(Date.now() - 60000),
      },
      {
        id: '6',
        content:
          'Analyze the social media activity around the time of the burglary.',
        role: 'user',
        timestamp: new Date(Date.now() - 40000),
      },
      {
        id: '7',
        content: `[Thinking…]
• Reviewing local buy/sell groups and classified ads between 00:00–06:00, June 21.
• Scanning for keywords: "electronics", "tools", "moving sale", and items matching stolen property description.
• Matching timestamps of posts with burglary event log and van sighting.
• Flagging new accounts with no local connections or recent profile activity spikes.
[End of thinking]`,
        role: 'assistant-thinking',
        timestamp: new Date(Date.now() - 35000),
      },
      {
        id: '8',
        content: `Social Media Analysis:
- Two suspicious posts in buy/sell groups within 90 minutes of the burglary, offering electronics and jewelry—minimal details, vague locations.
- Both accounts created within last 24 hours, no mutual friends, identical grammar and phrasing.
- Electronics seller posted at 1:55am, matching van presence on surveillance.

Insight:
These accounts likely created specifically for fencing stolen property. Recommend request data retention from platform, and consider setting up a controlled buy or digital trace. Pattern consistent with recent cluster of quick-flip burglaries tracked by CID analytics.

Would you like to escalate these leads, request subpoenas, or compare to previous burglary series?`,
        role: 'assistant',
        timestamp: new Date(Date.now() - 30000),
      },
    ],
    'ch-4': [
      {
        id: '1',
        content:
          'I need best practices for a mental health crisis response—subject is agitated but nonviolent.',
        role: 'user',
        timestamp: new Date(Date.now() - 400000),
      },
      {
        id: '2',
        content:
          'Per our Crisis Intervention Policy (Section 5.3.2) and L.R.S. 28:53 (Emergency Detention by Peace Officer), secure a safe perimeter and begin verbal de-escalation. Keep at least six feet distance, speak calmly and empathetically, and avoid sudden movements. Any hazards present (weapons, bystanders)? Any prior mental health calls here?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 380000),
      },
      {
        id: '3',
        content:
          'No weapons present. The subject asked to remain alone—previous call six months ago for similar agitation.',
        role: 'user',
        timestamp: new Date(Date.now() - 350000),
      },
      {
        id: '4',
        content:
          'Understood. De-escalation steps:\n' +
          '1) Offer Crisis Intervention Team response (Policy App. B §2).\n' +
          '2) Suggest voluntary wellness check by our mobile crisis unit.\n' +
          '3) If the subject remains a danger to self/others, invoke Emergency Detention under L.R.S. 28:53.\n' +
          'Document each offer and their response with timestamps.',
        role: 'assistant',
        timestamp: new Date(Date.now() - 320000),
      },
      {
        id: '5',
        content:
          'Yes, please generate that template outlining steps, policy citations, and statute references.',
        role: 'user',
        timestamp: new Date(Date.now() - 300000),
      },
      {
        id: '6',
        content:
          "Here's your template:\n" +
          '- **Scene Assessment** (Policy 5.3.2): Secure perimeter; note hazards.\n' +
          '- **Verbal De-escalation**: Maintain safe distance; use empathetic tone.\n' +
          '- **Crisis Intervention Team Offer**: Per Policy App. B §2—record acceptance/refusal.\n' +
          '- **Emergency Detention** (L.R.S. 28:53): If danger persists, initiate detention—include statutory citation.\n' +
          '- **Documentation**: Log all offers, responses, and actions with timestamps.\n\n' +
          'Would you like this formatted for your RMS?',
        role: 'assistant',
        timestamp: new Date(),
      },
    ],
    'ch-5': [
      {
        id: '1',
        content:
          "Let's coordinate a youth engagement event for the west side precinct.",
        role: 'user',
        timestamp: new Date(Date.now() - 300000),
      },
      {
        id: '2',
        content:
          'Great initiative! I can generate text-based deliverables: a press release draft, social media post copy, email invitation text, or flyer text. Which messaging focus would you like—mentorship showcase or community partnership highlights?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 280000),
      },
      {
        id: '3',
        content: "Let's highlight mentorship and community partnership.",
        role: 'user',
        timestamp: new Date(Date.now() - 250000),
      },
      {
        id: '4',
        content:
          '**Press Release Title:** "Louisiana State Police Launches Youth Mentorship Initiative on West Side"\n\n' +
          '**Lead Paragraph:** "On July 15, 2025, the West Side Precinct will host aspiring young leaders for a day of mentorship, safety workshops, and community dialogue, fostering stronger bonds between officers and residents."\n\n' +
          '**Sample Social Media Posts:**\n' +
          '1. "Join us July 15 for a Youth Mentorship Event! Officers and community leaders will share insights and guidance. #WestSideMentors"\n' +
          '2. "Mentorship matters. Learn how our officers empower youth through safety workshops and leadership sessions. RSVP today. #CommunityPartnership"\n\n' +
          '**Flyer Text:**\n' +
          '"Free Youth Mentorship Event\n' +
          'Date: July 15, 2025\n' +
          'Location: West Side Precinct\n' +
          'Meet local officers, build leadership skills, and strengthen community ties.\n' +
          'RSVP: joinus@lsp.gov"\n\n' +
          'Would you like any edits or additional text variations?',
        role: 'assistant',
        timestamp: new Date(Date.now() - 200000),
      },
      {
        id: '5',
        content:
          'This is great—can you also generate a short video script for officer testimonials?',
        role: 'user',
        timestamp: new Date(Date.now() - 150000),
      },
      {
        id: '6',
        content:
          "Certainly. Here's a 30-second script:\n\n" +
          '1. **Opening Scene:** Officer Smith greets teens at the precinct entrance and says, "I grew up here, and giving back means the world to me."\n\n' +
          '2. **Workshop Cut:** Officer Brown demonstrates a safety exercise: "Mentorship isn\'t just teaching—it\'s listening and learning together."\n\n' +
          '3. **Closing Scene:** Group shot with officers and participants. Voiceover: "Join us July 15 to connect, learn, and grow together. #WestSideMentors"\n\n' +
          "Let me know if you'd like alternative versions or timing adjustments.",
        role: 'assistant',
        timestamp: new Date(),
      },
    ],
    bodyCameraPolicy: [
      {
        id: '1',
        content:
          "Can you clarify our agency's protocol for body camera activation during a traffic stop?",
        role: 'user',
        timestamp: new Date(Date.now() - 1000000),
      },
      {
        id: '2',
        content:
          "Here's the traffic stop body camera policy:\n\n1. Activate camera before any citizen contact, including while approaching the vehicle.\n2. Maintain recording for the full duration of the stop, without interruption.\n3. Announce recording to the subject at first opportunity.\n4. Do not deactivate until the stop and all citizen contact is fully concluded.\n\nWould you like more detail on storage, supervisor review, or report integration?",
        role: 'assistant',
        timestamp: new Date(Date.now() - 900000),
      },
      {
        id: '3',
        content:
          'Yes—when is the exact moment to start recording? Some situations develop quickly.',
        role: 'user',
        timestamp: new Date(Date.now() - 800000),
      },
      {
        id: '4',
        content:
          'Best practice: Begin recording as soon as you form intent to initiate a stop—before lights/sirens, before any approach. This ensures full capture of officer observations, verbal commands, and subject reactions for evidentiary and liability purposes. When in doubt, start early.',
        role: 'assistant',
        timestamp: new Date(Date.now() - 700000),
      },
    ],
  },
  transcripts: {
    'bc-1': [
      {
        id: '1',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'Initiating traffic stop on silver sedan, plate ABC-123, for suspected DUI. Location: Highway 26, westbound, mile marker 43.',
        timestamp: '14:30:00',
      },
      {
        id: '2',
        speaker: 'Dispatch',
        content: 'Copy, Officer Smith. Plate ABC-123 logged. Backup available.',
        timestamp: '14:30:15',
      },
      {
        id: '3',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'Driver displays slurred speech, bloodshot eyes, and slow coordination. Requesting backup for field sobriety evaluation.',
        timestamp: '14:35:22',
      },
      {
        id: '4',
        speaker: 'Officer Jones',
        badge: '#67890',
        content:
          "Backup en route, ETA 2 minutes. Proceed with standard SFST—request driver's license, registration, proof of insurance.",
        timestamp: '14:36:05',
      },
      {
        id: '5',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'Driver, do you have your license and registration? (pause) You seem unsteady—have you had anything to drink today?',
        timestamp: '14:37:10',
      },
      {
        id: '6',
        speaker: 'Driver',
        content:
          "Uh, I had a couple of beers earlier, officer, but I'm fine to drive.",
        timestamp: '14:37:45',
      },
      {
        id: '7',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          "Alright. I'm going to conduct some standardized field sobriety tests. Follow my pen with your eyes only—no head movement.",
        timestamp: '14:38:10',
      },
      {
        id: '8',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'I observed six out of six clues on the Horizontal Gaze Nystagmus test. Now please stand heel-to-toe and walk nine steps forward, turn, and walk back.',
        timestamp: '14:38:55',
      },
      {
        id: '9',
        speaker: 'Driver',
        content:
          "(stumbles) Am I doing it right? Sorry, it's a bit slippery here.",
        timestamp: '14:39:30',
      },
      {
        id: '10',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'You stepped off the line twice and used your arms to balance. The test indicates impairment. One-leg stand next—lift your right foot six inches off the ground and count aloud.',
        timestamp: '14:40:05',
      },
      {
        id: '11',
        speaker: 'Dispatch',
        content: 'Officer Smith, confirm if you need breathalyzer at scene.',
        timestamp: '14:40:30',
      },
      {
        id: '12',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          "Affirmative—please send the handheld unit. Driver, I'm placing you under arrest for suspicion of DUI. You have the right to remain silent… (Miranda warning).",
        timestamp: '14:41:00',
      },
      {
        id: '13',
        speaker: 'Dispatch',
        content:
          'Handheld breathalyzer units dispatched. Station ETA is 1430 Sibley Street, approximately 8 minutes out.',
        timestamp: '14:41:20',
      },
      {
        id: '14',
        speaker: 'Officer Smith',
        badge: '#12345',
        content:
          'Driver refused on-scene breath test. I will transport to station for evidentiary breath test. Secure the vehicle and advise towing.',
        timestamp: '14:42:10',
      },
    ],

    'bc-2': [
      {
        id: '1',
        speaker: 'Officer Johnson',
        badge: '#67890',
        content:
          'Arrived at 1245 Oak Street for domestic disturbance. Neighbors reported shouting from inside.',
        timestamp: '18:05:00',
      },
      {
        id: '2',
        speaker: 'Officer Johnson',
        badge: '#67890',
        content:
          'Contacted male subject—appears agitated, confirmed verbal dispute with partner. No sign of assault or physical altercation.',
        timestamp: '18:07:45',
      },
    ],
    'bc-3': [
      {
        id: '1',
        speaker: 'Officer Lee',
        badge: '#22331',
        content:
          'Located suspicious vehicle, NE mall lot. Dark blue SUV, missing rear license plate.',
        timestamp: '16:12:00',
      },
      {
        id: '2',
        speaker: 'Officer Lee',
        badge: '#22331',
        content:
          'VIN scan—vehicle associated with recent shoplifting. Requesting secondary unit for vehicle search.',
        timestamp: '16:14:18',
      },
    ],
    'bc-4': [
      {
        id: '1',
        speaker: 'Officer Davis',
        badge: '#33221',
        content:
          'Wellness check: 782 Pine Lane. Elderly resident not answering door, reported by neighbor.',
        timestamp: '11:22:00',
      },
      {
        id: '2',
        speaker: 'Officer Davis',
        badge: '#33221',
        content:
          'Resident located, conscious but confused. Notified EMS, providing assistance until paramedics arrive.',
        timestamp: '11:25:33',
      },
    ],
  },
  transcriptChats: {
    'bc-1': [
      {
        id: 'tc-1',
        role: 'assistant',
        content:
          "Please confirm the driver's full name, date of birth, license number, and address.",
        timestamp: new Date(Date.now() - 1500000),
      },
      {
        id: 'tc-2',
        role: 'user',
        content:
          'Driver is Jane A. Doe, DOB January 5, 1987, DL S1234567, 123 Main St, Lafayette, LA.',
        timestamp: new Date(Date.now() - 1400000),
      },
      {
        id: 'tc-3',
        role: 'assistant',
        content:
          'Got it. Next, vehicle details: make, model, year, color, VIN, and insurance carrier/policy.',
        timestamp: new Date(Date.now() - 1300000),
      },
      {
        id: 'tc-4',
        role: 'user',
        content:
          '2018 Toyota Camry, silver, VIN 4T1BF1FK5JU123456, insured by State Farm, policy #987654321.',
        timestamp: new Date(Date.now() - 1200000),
      },
      {
        id: 'tc-5',
        role: 'assistant',
        content:
          'Please describe environmental conditions at the time: weather, lighting, road surface, traffic volume.',
        timestamp: new Date(Date.now() - 1100000),
      },
      {
        id: 'tc-6',
        role: 'user',
        content:
          'Clear skies, dry pavement, daylight, moderate traffic—approximately one car every 30 seconds.',
        timestamp: new Date(Date.now() - 1000000),
      },
      {
        id: 'tc-7',
        role: 'assistant',
        content:
          'For the probable cause narrative, confirm odor observations, any admission of drinking, and your basis (training/experience).',
        timestamp: new Date(Date.now() - 900000),
      },
      {
        id: 'tc-8',
        role: 'user',
        content:
          "I detected a strong odor of intoxicants on the driver's breath; they admitted to two beers. Based on my training, this supported impairment suspicion.",
        timestamp: new Date(Date.now() - 800000),
      },
      {
        id: 'tc-9',
        role: 'assistant',
        content:
          'Which device was used for the preliminary breath test? Provide make, model, serial number, and time administered.',
        timestamp: new Date(Date.now() - 700000),
      },
      {
        id: 'tc-10',
        role: 'user',
        content: 'Handheld Intoxilyzer 8000, SN 56789, administered at 14:42.',
        timestamp: new Date(Date.now() - 600000),
      },
      {
        id: 'tc-11',
        role: 'assistant',
        content:
          'Any additional witness statements or backup officer observations to include?',
        timestamp: new Date(Date.now() - 500000),
      },
      {
        id: 'tc-12',
        role: 'user',
        content:
          'Officer Jones (#67890) noted the same impairment clues and assisted during FSTs; his statement concurs.',
        timestamp: new Date(Date.now() - 400000),
      },
      {
        id: 'tc-13',
        role: 'assistant',
        content:
          "Excellent. I'll draft the complete DUI report with these details. Would you like to review it now?",
        timestamp: new Date(Date.now() - 300000),
      },
    ],

    'bc-2': [
      {
        id: 'tc-4',
        role: 'assistant',
        content:
          'This is flagged as a domestic disturbance. I can auto-generate a scene report and highlight subject statements, scene conditions, and absence of injury. Where would you like to begin?',
        timestamp: new Date(Date.now() - 700000),
      },
      {
        id: 'tc-6',
        role: 'assistant',
        content:
          'Based on your bodycam recording, I can generate a draft report: summary of verbal conflict, statements from involved parties, and confirmation of no observed injuries. Proceed?',
        timestamp: new Date(),
      },
    ],
    'bc-3': [
      {
        id: 'tc-5',
        role: 'assistant',
        content:
          'Suspicious vehicle confirmed as matching recent BOLO. Would you like related case files, or should I begin pre-filling evidence and recovery documentation?',
        timestamp: new Date(Date.now() - 600000),
      },
      {
        id: 'tc-7',
        role: 'assistant',
        content:
          'Vehicle matches shoplifting alert. Prefilling case reference and evidence collection sections now. Anything to add before submission?',
        timestamp: new Date(),
      },
    ],
    'bc-4': [
      {
        id: 'tc-8',
        role: 'assistant',
        content:
          'Welfare check completed—elder at risk. I can flag for follow-up and document EMS response in the official report. Confirm update?',
        timestamp: new Date(),
      },
    ],
  },
  performance: {
    summary:
      'Officer consistently demonstrates attention to detail, thorough scene documentation, and procedural compliance. Recent activity shows strong victim interviewing and evidence handling, contributing to case solvability rates and positive feedback.',
    recentContributions: [
      {
        date: '2024-01-15',
        action: 'Detailed scene documentation – Willow St. burglary',
        points: '+5',
      },
      {
        date: '2024-01-14',
        action: 'Effective victim interview – Domestic disturbance',
        points: '+3',
      },
      {
        date: '2024-01-12',
        action: 'Evidence cataloging – Stolen vehicle recovery',
        points: '+4',
      },
    ],
  },
  reports: {
    default: {
      caseNumber: '2024-0123-BR',
      location: '123 Main Street',
      incidentType: 'Burglary – Breaking and Entering',
      narrative: `On January 15, 2024, at approximately 1430 hours, I, Officer Smith (#12345), responded to a reported burglary at 123 Main Street.
Upon arrival, forced entry observed at the front door—lock mechanism tampered and doorframe damaged. Premises clear on entry; no suspects present.
Scene documented with photographs and search for physical evidence. Witness statements collected from adjacent residents. Surveillance canvass negative.
Report prepared for review as a factual record of response and investigation.`,
    },
    'bc-2': {
      caseNumber: '2024-0124-DD',
      location: '1245 Oak Street',
      incidentType: 'Domestic Disturbance',
      narrative: `At approximately 1805 hours, Officer Johnson (#67890) responded to a domestic disturbance at 1245 Oak Street.
Interviewed male occupant; confirmed verbal dispute with partner, no physical altercation. Neighbors heard raised voices only—no evidence of violence.
Both subjects advised of community resources. Scene cleared without incident. Report forwarded for review if future calls occur.`,
    },
    'bc-3': {
      caseNumber: '2024-0125-SV',
      location: 'Mall Parking Lot (NE corner)',
      incidentType: 'Suspicious Vehicle / Stolen Property Recovery',
      narrative: `On January 13, 2024, Officer Lee (#22331) located a suspicious dark blue SUV (no rear plate) matching active BOLO.
VIN returned as stolen from previous retail theft case. On search, recovered stolen merchandise. One male detained without incident. All items cataloged, photographed, and secured for CID processing.`,
    },
    'bc-4': {
      caseNumber: '2024-0126-WC',
      location: '782 Pine Lane',
      incidentType: 'Wellness Check – Elderly Assist',
      narrative: `Officer Davis (#33221) conducted a welfare check at 782 Pine Lane for elderly resident. Located subject conscious, but disoriented and dehydrated.
EMS responded and transported subject for medical evaluation. Incident logged and social services follow-up as potential neglect risk.`,
    },
  },
  affidavit: {
    title: 'Affidavit of Truth',
    declarations: [
      'That I am a sworn law enforcement officer employed by this agency and authorized to submit this report.',
      'That the information contained herein is accurate to the best of my knowledge and belief.',
      'That this report was prepared in the regular course of official law enforcement duties.',
      'That I understand this report may be used as an official document in administrative, legal, or judicial proceedings.',
      'That I acknowledge any knowingly false statements may result in disciplinary action or prosecution.',
    ],
    confirmationText:
      'I affirm that the contents of this report are true and accurate to the best of my knowledge and belief.',
  },
}
